module.exports = __webpack_public_path__ + "static/media/background-isa-dark.38d6e361.svg";